import { CommonModule } from '@angular/common'
import { Component, input, ChangeDetectionStrategy } from '@angular/core'
import { MatTooltipModule } from '@angular/material/tooltip'

@Component({
  selector: 'lib-coming-soon',
  imports: [MatTooltipModule, CommonModule],
  templateUrl: './coming-soon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './coming-soon.component.scss',
})
export class ComingSoonComponent {
  readonly disabled = input(false)

  readonly preventEvents = input(false)
}
